export const COPILOT_WEATHER_SETTING = 'EnableWeather';
export const SAMSARA_PARTNER_ID = 'SAMVX2';
export const SAMSARA_DRIVER_PARTNER_ID = 'SAMDRV';
export const DATE_TIME_LOCALE = navigator.language;
export const RECENT = 'location-arrow-green';
export const OLD = 'location-arrow-yellow';
export const STALE = 'location-arrow-gray';
export const MIDNIGHT = '00:00';
export const MS_PER_DAY = 86_400_000;

export const ALK_PARTNER_ID = 'AL4BA0';

/**
 * Default profile image source in the TID staging environment.
 */
export const DEFAULT_STAGING_PROFILE_SOURCE =
  'https://us.stage.id.trimblecloud.com/ui/resources/default_profile.png?v=1';

/**
 * Default profile image source in the TID prod environment.
 */
export const DEFAULT_PROFILE_SOURCE =
  'https://us.id.trimble.com/ui/resources/default_profile.png?v=1';

/**
 * This is used to check for bucket accounts which need to be treated differently sometimes
 */
export const TRIMBLE_BUCKET_PARTNER_REGEX = /^(TMAMVB|TMMDBF|TMAMDB)$/;
